const STORAGE_PREFIX = "gridLayouts:";

export function gridLayoutsStorageKey(userKey) {
    return `${STORAGE_PREFIX}${userKey || "anon"}`;
}

export function readLayoutsMirror(userKey) {
    try {
        const raw = localStorage.getItem(gridLayoutsStorageKey(userKey));
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
}

export function writeLayoutsMirror(userKey, layouts) {
    try {
        localStorage.setItem(
            gridLayoutsStorageKey(userKey),
            JSON.stringify(layouts && typeof layouts === "object" ? layouts : {})
        );
    } catch {
        // ignore quota / private mode
    }
}

export function patchLayoutsMirror(userKey, gridId, layoutOrNull) {
    const current = readLayoutsMirror(userKey);
    if (layoutOrNull == null) {
        delete current[gridId];
    } else {
        current[gridId] = layoutOrNull;
    }
    writeLayoutsMirror(userKey, current);
    return current;
}

export function normalizeLayout(layout) {
    if (!layout || typeof layout !== "object") return null;
    const sortModel = Array.isArray(layout.sortModel)
        ? layout.sortModel
              .filter((item) => item?.field)
              .map((item) => ({
                  field: String(item.field),
                  sort: item.sort === "asc" ? "asc" : "desc",
              }))
        : [];
    const columnVisibilityModel =
        layout.columnVisibilityModel && typeof layout.columnVisibilityModel === "object"
            ? { ...layout.columnVisibilityModel }
            : {};
    const columnWidths = {};
    if (layout.columnWidths && typeof layout.columnWidths === "object") {
        for (const [field, width] of Object.entries(layout.columnWidths)) {
            const n = Number(width);
            if (Number.isFinite(n) && n > 0) columnWidths[field] = n;
        }
    }
    return {
        sortModel,
        columnVisibilityModel,
        columnWidths,
        updatedAt: layout.updatedAt || null,
    };
}

export function layoutsEqual(a, b) {
    return JSON.stringify(a || null) === JSON.stringify(b || null);
}

export function snapshotFromState({
    sortModel,
    columnVisibilityModel,
    columnWidths,
}) {
    return normalizeLayout({
        sortModel,
        columnVisibilityModel,
        columnWidths,
    });
}
